import { useRoutes } from 'react-router-dom';
import LoginRoutes from './LoginRoutes';
import HomeRoutes from './HomeRoutes';
import MapRoutes from './MapRoutes';
import ScopeRoutes from './ScopeRoutes';
import UpdateRoutes from './UpdateRoutes';
import { useContext, useState, useEffect } from 'react';
import { AppsContext } from 'AppsContext';
import React from 'react';
import MapService from 'Services/MapService';
import CheckoutRoutes from './CheckoutRoute';
import CartRoutes from './CartRoute';
import ProductOfferRoutes from './ProductOfferRoute';
import ProductRoutes from './ProductRoute';

export default function ThemeRoutes() {
  const appsContext = useContext(AppsContext);
  const [dynamicRoutes, setDynamicRoutes] = useState([]);

  const importComponent = async (path) => {
    try {
      console.log('path',path)
      const module = await import(`components/MapData/${path}`);
      return module.default;
    } catch (err) {
      console.log('Error importing component:', err);
      return null;
    }
  };

  useEffect(() => {
    const fetchDynamicRoutes = async () => {
      try {
        // Get apps list from context or fetch it
        let appsList = appsContext.appsContext;
        console.log('appsList contents:', appsList);

        if (!Array.isArray(appsList)) {
          console.log('AppsContext.appsContext not set or not array, fetching...');
          const res = await MapService.getApplications();
          appsContext.setAppsContext(res);
          appsList = res;
        } else {
          console.log('Using existing appsContext.appsContext:', appsList);
        }

        // Defensive fallback
        if (!Array.isArray(appsList)) {
          appsList = [];
          console.warn('appsList is still not an array, defaulting to []');
        }

        // Map over appsList to create route promises
        const routesPromises = appsList.map(async (config) => {
          const { root } = config;
          const path = `${root}Data`;
          const component = await importComponent(path);

          if (!component) return null;

          return {
            path: `/${root}/:geoId`,
            element: React.createElement(component)
          };
        });

        const resolvedRoutes = await Promise.all(routesPromises);
        setDynamicRoutes(resolvedRoutes.filter(route => route !== null));
      } catch (err) {
        console.error('Error fetching or setting dynamic routes:', err);
      }
    };

    fetchDynamicRoutes();
  }, [appsContext]);

  return useRoutes([
    LoginRoutes,
    HomeRoutes,
    UpdateRoutes,
    MapRoutes,
    ...dynamicRoutes,
    ScopeRoutes,
    CheckoutRoutes,
    CartRoutes,
    ProductOfferRoutes,
    ProductRoutes
  ]);
}
